import {
  GOOGLE_ADS_GENERATOR_SCRIPT,
  GOOGLE_ADS_META_PLATFORM_ACCOUNT_CONTENT,
  GOOGLE_ADS_META_PLATFORM_ACCOUNT_NAME,
  GOOGLE_ADS_META_PLATFORM_AUTHOR_URL_NAME,
  GOOGLE_ADS_META_PLATFORM_DOMAIN_CONTENT,
  GOOGLE_ADS_META_PLATFORM_DOMAIN_NAME,
  GOOGLE_ADS_META_USER_ACCOUNT_NAME,
} from '../constansts';

export const appendScript = (data_ad_client: string, site_url: string) => {
  const elemDiv = document.createElement('script');
  elemDiv.src = `${GOOGLE_ADS_GENERATOR_SCRIPT}?client=${data_ad_client}&host=${GOOGLE_ADS_META_PLATFORM_ACCOUNT_CONTENT}`;
  elemDiv.async = true;
  elemDiv.setAttribute('data-hook', 'adsbygoogle-script');
  document.body.insertBefore(elemDiv, document.body.firstChild);
  document.head.innerHTML += `<meta name=${GOOGLE_ADS_META_PLATFORM_ACCOUNT_NAME} content=${GOOGLE_ADS_META_PLATFORM_ACCOUNT_CONTENT}>
  <meta name=${GOOGLE_ADS_META_PLATFORM_DOMAIN_NAME} content=${GOOGLE_ADS_META_PLATFORM_DOMAIN_CONTENT}>
  <meta name=${GOOGLE_ADS_META_USER_ACCOUNT_NAME} content=${data_ad_client}><meta name=${GOOGLE_ADS_META_PLATFORM_AUTHOR_URL_NAME} content=${site_url}>`;
};
